// extracted by mini-css-extract-plugin
module.exports = {"Container":"ManageCustomerList_Container__3W-a3","CustomerList":"ManageCustomerList_CustomerList__1Lo31","AssociatedCampaigns":"ManageCustomerList_AssociatedCampaigns__30A3T"};